import { render, staticRenderFns } from "./atlas_F.vue?vue&type=template&id=1bddd365"
import script from "./atlas_F.vue?vue&type=script&lang=js"
export * from "./atlas_F.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports